export const returnItemInspectionNotes = {
  id: "returns.returnsDetail.returnItemInspectionNotes",
  defaultMessage: "Inspection notes:",
};
